export const trinnvisAsPartnerTemplateId = 14659;
